import React from 'react';
import { Button, Typography } from '@mui/material';
import { useTheme } from '@mui/system';

export default function PrimaryButton({
    onClick,
    disabled = false,
    children,
    fullWidth = true,
    sx = {}
}) {
    const theme = useTheme();

    return (
        <Button
            variant="contained"
            sx={{
                width: fullWidth ? '100%' : 'auto',
                pl: '4rem',
                pr: '4rem',
                backgroundColor: theme.palette.primary.main,
                '&:hover': {
                    backgroundColor: theme.palette.primary.dark,
                },
                ...sx
            }}
            onClick={onClick}
            disabled={disabled}
        >
            <Typography variant="subtitle2" fontWeight={600} color={theme.palette.text.contrast}>
                {children}
            </Typography>
        </Button>
    );
}
